export const CREATE_DOWNLOAD_NOTIFICATION = 'CREATE_DOWNLOAD_NOTIFICATION';
export const DISMISS_DOWNLOAD_NOTIFICATION = 'DISMISS_DOWNLOAD_NOTIFICATION';
export const CLEAR_DOWNLOAD_COUNTER = 'CLEAR_DOWNLOAD_COUNTER';
export const REMOVE_PENDING_DOWNLOADS = 'REMOVE_PENDING_DOWNLOADS';
export const ADD_PENDING_DOWNLOADS = 'ADD_PENDING_DOWNLOADS';
export const SET_DOWNLOAD_NOTIFICATION_ID = 'SET_DOWNLOAD_NOTIFICATION_ID';
export const REMOVE_FAILED_DOWNLOADS = 'REMOVE_FAILED_DOWNLOADS';
